<template>
  <b-modal
    id="mc-modal-fo-list"
    class="mc-modal"
    :title="$t('routeOptimization.label.assignmentList')"
    size="md"
    centered
    scrollable
  >
    <div class="card-body p-2">
      <McTable
        :apiClient="apiClient"
        :fields="fields"
        :customHandlers="customHandlers"
        :hasCheckbox="false"
      >
      <template v-slot:[`cell(vehicle.license_plate)`]="{ item }">
        {{ item?.vehicle?.license_plate ?? '-' }}
        <div
          class="text-muted"
          v-if="item?.vehicle?.hull_no"
        >
          {{ item?.vehicle?.hull_no }}
        </div>
      </template>
    </McTable>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.close')"
          @click="cancel()"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import McTable from '@/components/McTable'
import McButton from '@/components/McButton'

export default {
  components: {
    McTable,
    McButton,
  },
  props: {
    apiClient: {},
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    fields() {
      return [
        {
          label: this.$t('routeOptimization.fields.foNumber'),
          key: 'number',
          isSortable: true,
          isRedirectable: true,
        },
        {
          label: this.$t('routeOptimization.fields.licensePlate'),
          key: 'vehicle.license_plate',
          isSortable: true,
        },
      ]
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
  },
  methods: {
    handleClickRow(item) {
      this.$router.push({ name: 'Fleet Task Detail', params: { id: item.id } })
    },
  },
}
</script>
